import React from 'react'
import { DatePicker } from '@ow/comps'
import locale from '@ow/comps/locale/zh-CN'
import DateRangeFilter from '../date-range/filter'

const Render = function ({ opts = {}, value, style, onChange }) {
  const { currentQueryType } = opts
  if (currentQueryType === 'dayRange') {
    return (
      <DateRangeFilter
        opts={{ ...opts, showTime: false, showMonth: false, monthType: false }}
        value={value}
        style={style}
        onChange={onChange}
      />
    )
  }
  return (
    <DatePicker
      {...opts}
      placeholder={opts.hint || `请选择${opts.title}`}
      style={{ height: '34px' }}
      locale={locale}
      selectStyles={{
        control: (styles) => ({
          ...styles,
          width: '235px',
        }),
      }}
      inputStyle={{
        height: '100%',
        borderBottomLeftRadius: '0',
        borderTopLeftRadius: '0',
        ...style,
      }}
      monthType="range"
      onChange={(e) => {
        console.log('rangevalue---111', e)
        // onChange(dayjs(e).format('YYYY-MM-DD'))
        onChange(e)
        // onChange(new Date(e).getTime())
      }}
      showTime={opts.showTime}
      showMonth={opts.showMonth}
      selectedDateBackground="rgb(var(--ow-primary-color))"
      selectedDate={value && new Date(value)} // 这里new Date应该放到里面处理，因为monthType=range时结构为 { startDate: Date, endDate: Date }
    />
  )
}

export default Render
